import React from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Logo from "../../../../public/images/logo-new.svg";
import { BasicInfoContainer, ImageContainer, TitleContainer, Title, Subtitle } from "../BasicInfo/BasicInfo.styles";

interface EmailSentProps extends WithRouterProps {
}

const EmailSent: React.FC<EmailSentProps> = ({
}) => {
    return (
      <BasicInfoContainer>
        <ImageContainer>
          <Logo />
        </ImageContainer>
        <TitleContainer>
          <Title>Check Your Email</Title>
          <Subtitle>
            If the email address exists in our system, you will receive a password reset email shortly.
          </Subtitle>
        </TitleContainer>
      </BasicInfoContainer>
    );
};

EmailSent.displayName = "EmailSent";

const ComponentWithRouter = withRouter(EmailSent)

export { ComponentWithRouter as EmailSent };
